module.exports = __webpack_public_path__ + "static/media/IMG_20191204_134119.0f11eb83.jpg";